import React from 'react';
import { format } from 'date-fns';
import './_banners.scss';
import FacebookLoginButton from '../WhatsApp/FacebookLoginButton';

export default function WhatsappBanner(props) {
  const {
    access_token,
    handleLoginSuccess,
    title = '',
    description = '',
    isLoggedIn = false,
    isAuthenticated = false,
  } = props;
  const date = format(new Date(), 'EEEE, MMMM dd');

  return (
    <div className="banner">
      <div className="banner-time">{date}</div>
      <div className="banner-title">{title}</div>
      <div className="banner-desc">{description}</div>
      <div className="d-flex gap-2">
        {!isLoggedIn && !isAuthenticated && (
          <FacebookLoginButton accessToken={access_token} onLoginSuccess={handleLoginSuccess} />
        )}
      </div>
    </div>
  );
}
